import { useContext } from "react";

import { CartContext, CartContextInterface } from "../contexts/cart/context";

export const useCart = (): CartContextInterface => useContext(CartContext);
